import { Empty } from "antd";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import styled from "styled-components";
import Image from "next/image";
import { cdnHost, version } from "@/utils";

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 186px);

  background: #f7f9ff;
  text-align: center;
  /* padding-top: 160px; */

  .empty-text {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin-top: 16px;
  }
`;

export default function NotFound() {
  return (
    <Container>
      <Empty
        image={
          <Image
            src={`${cdnHost}image/web-site/404.png?v=${version}`}
            alt="404"
            width={220}
            height={160}
          />
        }
        imageStyle={{ height: 160 }}
        description={<div className="empty-text"></div>}
      />
    </Container>
  );
}

// 国际化需要加
export async function getStaticProps({ locale = "zh" }: any) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["index"])),
    },
  };
}
